import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { Link, Redirect } from 'react-router-dom';
import EventBus from "../common/EventBus.js";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import Pagination from "../common/listing/pagination.component.jsx";
import NewCreditMemoModal from "../invoice/credit-memo/NewCreditMemoModal";
import CreditMemoStatusBadge from "../invoice/creditmemostatus.component.jsx";
import CreditMemoTypeIcon from "../invoice/creditmemotypeicon.component.jsx";
import EditAndRefundCreditMemoModal from "../invoice/editandrefundcreditmemomodal.component.jsx";

class CreditMemoListByContact extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            contactId: this.props.contactId || '',
            contactType: '',
            customerAccountIds: [],
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            customerAccount: null,
            noEmployee: false,
            modal: '',
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.openCreditMemoCreationModal = this.openCreditMemoCreationModal.bind(this)
        this.loadCreditMemosByContactId = this.loadCreditMemosByContactId.bind(this)
        this.refreshCreditMemoList = this.refreshCreditMemoList.bind(this)
    }

    componentDidMount() {
        if (this.state.contactId) {
            this.refreshCustomerAccount(this.state.contactId)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.refreshCustomerAccount(nextProps.contactId)
    }

    refreshCustomerAccount(contactId) {
        if (!contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            const noEmployee = res.attributes.contact.type === 'organizations' && !res.attributes.contact.attributes.primaryContactId
            this.setState({
                customerAccount: res,
                noEmployee: noEmployee,
                contactId: contactId,
                customerAccountIds: res.attributes.customerAccountIds || [],
                contactType: res.attributes.contactType || '',
            }, this.loadCreditMemosByContactId)
        })
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.credit_memos.list.headers.id_label"
                defaultMessage="ID"
            />,
        ]
        if (this.state.contactType === 'organizations') {
            headers.push(<FormattedMessage
                id="customers.credit_memos.list.headers.employee_label"
                defaultMessage="Employee"
            />)
        }
        headers = headers.concat([
            <FormattedMessage
                id="customers.credit_memos.list.headers.created_date_label"
                defaultMessage="Created date"
            />,
            <FormattedMessage
                id="customers.credit_memos.list.headers.captured_date_label"
                defaultMessage="Captured date"
            />,
            <FormattedMessage
                id="customers.credit_memos.list.headers.status_label"
                defaultMessage="Status"
            />,
            <FormattedMessage
                id="customers.credit_memos.list.headers.amount_label"
                defaultMessage="Amount"
            />,
        ])
        return headers
    }

    row(creditMemo) {
        let rows = [
            <span>
                <a href={'#'} onClick={this.openCreditMemoEditionModal(creditMemo.id)}>
                    <CreditMemoTypeIcon value={creditMemo.type} /> {creditMemo.identifier}
                </a>
                <small className={'ml-2'}>{creditMemo.notes}</small>
            </span>,
        ]
        if (this.state.contactType === 'organizations') {
            rows.push(creditMemo.contact ?
                <Link className={creditMemo.contact.isArchived ? "text-danger" : ""} to={'/contacts/' + creditMemo.contactId + '/details'}>
                    {creditMemo.contact.name}
                </Link> : '-')
        }
        rows = rows.concat([
            <span>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(creditMemo.createdAt)} />
            </span>,
            <span>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(creditMemo.capturedDate ?? creditMemo.createdAt)} />
            </span>,
            <CreditMemoStatusBadge
                status={creditMemo.status}
            />,
            <span>
                <FormattedNumber
                    style="currency"
                    currency={creditMemo.currency}
                    value={creditMemo.amount}
                />
                {creditMemo.status === 'partially-applied' ? <span className={'ml-1'}>
                    (<FormattedMessage
                        id="customers.credit_memos.list.credit_left"
                        defaultMessage="{amount} left"
                        values={{
                            amount: <FormattedNumber
                                style="currency"
                                currency={creditMemo.currency}
                                value={creditMemo.remainingAmount}
                            />

                        }}
                    />)
                </span> : ''}
            </span>,
        ])
        return rows
    }

    loadCreditMemosByContactId() {
        let postData = {
            keywords: '*',
            objects: ['credit-memos'],
            fields: ['identifier', 'contact.name'],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                contactId: this.state.customerAccountIds,
                billingType: ['one-time'],
                "status{notOneOf};": ["pending"],
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }

    openCreditMemoCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewCreditMemoModal
                contactId={this.state.contactId}
                onClose={() => {
                    this.setState({ modal: '' })
                    setTimeout(this.refreshCreditMemoList, 2000)
                }}
            />
        })
    }

    openCreditMemoEditionModal(id) {
        return function (event) {
            event.preventDefault()
            this.setState({
                modal: <EditAndRefundCreditMemoModal
                    contactId={this.state.contactId}
                    creditMemoId={id}
                    customerAccount={this.state.customerAccount}
                    onClose={(objectId, objectType) => {
                        if (objectId) {
                            this.setState({
                                modal: <Redirect
                                    to={{ pathname: GlobalHelper.getObjectEditPathByObjectType(objectId, objectType) }}>
                                </Redirect>
                            })
                        } else {
                            this.setState({ modal: '' })
                            setTimeout(this.refreshCreditMemoList, 2000)
                        }
                    }}
                />
            })
        }.bind(this)
    }

    refreshCreditMemoList() {
        this.setState({
            activePage: 1,
        }, this.loadCreditMemosByContactId)
        EventBus.dispatch(EventBus.TopicCustomerBalanceUpdate, {})
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, this.loadCreditMemosByContactId)
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.refreshCustomerAccount(this.state.contactId)
        setTimeout(this.refreshCustomerAccount, 2000)
        EventBus.dispatch(EventBus.TopicRefreshCustomerDetails, {
            contactId: this.state.contactId,
        })
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.modal}
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        <div>
                            {!this.state.noEmployee ? <button onClick={this.openCreditMemoCreationModal}
                                className="btn btn-primary btn-sm mr-2">
                                <Icon value={"file-invoice-dollar"} />
                                <FormattedMessage
                                    id="customers.credit_memos.list.new_credit_memo_btn"
                                    defaultMessage="New credit memo"
                                />
                            </button> : null}
                        </div>
                    </div>}
                />
            </div>

        );
    }
}

export default CreditMemoListByContact





// WEBPACK FOOTER //
// ./src/customer/creditmemolist.component.jsx